import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import MessageSenderSimple from '../components/general/MessageSenderSimple';
import CommentsList from '../components/lists/comments/CommentsList';
import useCommentsListAndCreate from './useCommentsListAndCreate';

const CommentsListAndCreate = ({
  t,
  currentUser,
  parentGuid,
  comments = [],
  onPublishComment,
  placeholder,
  inputLabel,
  onDelete,
  onEdit,
  disabled = false,
  maxComments = false,
  onMarkAsRead,
  showFeedbackOption,
  onFeedback,
  feedbackQuestionType,
}) => {
  const { hasComments, isViewAllVisible, listRef, onShowAll, viewAllLabel, visibleComments } = useCommentsListAndCreate({ comments, maxComments, t });

  return (
    <div className="comments-list-and-create">
      {hasComments && (
        <div className="comments-list-and-create__list" ref={listRef}>
          <CommentsList
            parentGuid={parentGuid}
            currentUser={currentUser}
            comments={visibleComments}
            onEdit={onEdit}
            onDelete={onDelete}
            maxComments={maxComments}
            onMarkAsRead={onMarkAsRead}
            disabled={disabled}
          />
        </div>
      )}
      {isViewAllVisible && (
        <button className="comments-list-and-create__view-all" onClick={onShowAll} type="button">
          {viewAllLabel}
        </button>
      )}
      {!disabled && (
        <div className="comments-list-and-create__sender">
          <MessageSenderSimple
            disabled={disabled}
            currentUser={currentUser}
            onPublishComment={onPublishComment}
            parentGuid={parentGuid}
            placeholder={placeholder}
            label={inputLabel}
            showFeedbackOption={showFeedbackOption}
            onFeedback={onFeedback}
            feedbackQuestionType={feedbackQuestionType}
          />
        </div>
      )}
    </div>
  );
};

CommentsListAndCreate.propTypes = {
  comments: PropTypes.array,
  disabled: PropTypes.bool,
  onMarkAsRead: PropTypes.func,
  showFeedbackOption: PropTypes.bool,
  onFeedback: PropTypes.func,
  feedbackQuestionType: PropTypes.string,
  currentUser: PropTypes.object,
  parentGuid: PropTypes.string,
  onPublishComment: PropTypes.func,
  placeholder: PropTypes.string,
  inputLabel: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  maxComments: PropTypes.number,
  t: PropTypes.func,
};

export default withTranslation(['common', 'placeholder', 'my-courses'])(CommentsListAndCreate);
